import { createContext, useState, useContext, useMemo } from "react";
import type { Theme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

type DrawerContextType = {
  isLargeScreen: boolean;
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
};

type DrawerContextProviderProps = {
  children: React.ReactNode;
};

const DrawerContext = createContext<DrawerContextType>({
  isLargeScreen: false,
  isOpen: false,
  setIsOpen: (_value: boolean) => {},
});

export const DrawerContextProvider = ({
  children,
}: DrawerContextProviderProps) => {
  const isLargeScreen = useMediaQuery((theme: Theme) =>
    theme.breakpoints.up("lg")
  );

  const [isOpen, setIsOpen] = useState(isLargeScreen);

  const value = useMemo(
    () => ({
      isOpen,
      setIsOpen,
      isLargeScreen,
    }),
    [isLargeScreen, isOpen]
  );

  return (
    <DrawerContext.Provider value={value}>{children}</DrawerContext.Provider>
  );
};

export default function useDrawer() {
  return useContext(DrawerContext);
}
